/**
 * @author       grady@zumper.com (Grady Kuhnline)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  toStoredData.ts
 */

import { ExpirableStorageOptions } from '../types/ExpirableStorageOptions'
import { StoredData } from '../types/StoredData'

export const toStoredData = <TValue = any>(
  value: TValue,
  options: ExpirableStorageOptions
): StoredData<TValue> => [value, options.version, options.ttl, Date.now()]
